<div class="simple-items" fxLayout="column" fxLayoutAlign="space-between stretch" fxFill>
  <form [formGroup]="simpleItemsForm" fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="20px">
    <dashboard-module-item-core [dialogData]="dialogData" formControlName="moduleItemCore"></dashboard-module-item-core>
  </form>
  <div
    class="simple-items__actions"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.MODULES, PRIVILEGE_ACTIONS.ALL)"
  >
    <button mat-raised-button color="primary" (click)="closeModuleItemDialog()">
      {{ 'Cancel' | uppercase }}
    </button>
    <button mat-raised-button color="primary" (click)="saveModuleItem()">
      {{ 'Save' | uppercase }}
    </button>
  </div>
</div>
